import React, { Component } from "react";
import RadioButton from "../../../../../../../components/ZUILib/RadioButton";
import { constAPISuccess, constAPIFailure } from '../../../../../../../utils/clientConstant';
import commonUtil from "../../../../../../../utils/commonUtil";
import CircularProgressBar from "./CircularProgressBar";
import giftBoxIconDisabled from "../../../../../../../../assets/web/images/icons/giftlist/gift_box_icon_disabled.svg";
import giftBoxIconEnabled from "../../../../../../../../assets/web/images/icons/giftlist/gift_box_icon_enabled.svg";

import * as giftListActions from "../../../actions";
import Image from "../../../../../../../components/ZUILib/Image";
import OrderInfo from "./OrderInfo";
const { saveEventThresholdGiftDetails } = giftListActions;

class EventGiftSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAddressId: "",
      userDeliveryAddressOptions: [],
      disableHomeButton: false,
      disableStoreButton: false,
      progress: 0,
      selectedProgressObj : {},
      giftThresholdAmount: '0',
      skuInfo: {},
      totalPurchaseAmount: 0,
    };
  }

  progressText = {
    progress0: {
      green: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalodelevento.progress.text.green.label"
      ),
      grey: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalodelevento.progress0.text.grey.label"
      ),
      giftBoxIcon: giftBoxIconDisabled,
      progress: 0
    },
    progress25: {
      green: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalodelevento.progress25.text.green.label"
      ),
      grey: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalodelevento.progress25.text.grey.label"
      ),
      giftBoxIcon: giftBoxIconEnabled,
      progress: 25
    },
    progress50: {
      green: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalodelevento.progress25.text.green.label"
      ),
      grey: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalodelevento.progress25.text.grey.label"
      ),
      giftBoxIcon: giftBoxIconEnabled,
      progress: 50
    },
    progress75: {
      green: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalodelevento.progress25.text.green.label"
      ),
      grey: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalodelevento.progress25.text.grey.label"
      ),
      giftBoxIcon: giftBoxIconEnabled,
      progress: 75
    },
    progress100: {
      green: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalodelevento.progress100.text.green.label"
      ),
      grey: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalodelevento.progress100.text.grey.label"
      ),
      giftBoxIcon: giftBoxIconEnabled,
      progress: 100
    },
  }

  componentDidMount() {
    const {userEventThresholdGiftDetails, deliveryAddress, purchaseInfoDetails } = this.props;

    let totalPurchaseAmount = purchaseInfoDetails?.totalPurchaseAmount || 0;

    if(deliveryAddress && deliveryAddress.deliveryAddressInfo && deliveryAddress.deliveryAddressInfo.addresses){

      const addressOptions = [
        {
          id: "liverpoolStore",
          value: "liverpoolStore",
          title: "En cualquier tienda Liverpool",
          displayName: "En cualquier tienda Liverpool",
          labelResourceId: "En cualquier tienda Liverpool",
        },
      ]

      deliveryAddress.deliveryAddressInfo.addresses.forEach((address) => {
        let addressObj = {
          id: address?.addressId,
          value: address?.addressId,
          title: `Recibir en ${address?.nickname || ''}`,
          displayName: `Recibir en ${address?.nickname || ''}`,
          labelResourceId: `Recibir en ${address?.nickname || ''}`,
          addressObj: address
        }

        addressOptions.push(addressObj);
      })

      this.setState({
        userDeliveryAddressOptions: addressOptions || []
      })
    }

    let selectedAddressId = userEventThresholdGiftDetails?.data?.giftInfo?.giftAddressId || "";

    if(userEventThresholdGiftDetails?.data?.giftInfo?.storeOpted && !selectedAddressId){
      selectedAddressId = "liverpoolStore";
    }


    const giftThresholdAmount = userEventThresholdGiftDetails?.data?.giftInfo?.giftThresholdAmount || '0';

    const disableHomeButton = userEventThresholdGiftDetails?.data?.giftInfo?.disableHomeButton ? true : false;

    const disableStoreButton = userEventThresholdGiftDetails?.data?.giftInfo?.diableStoreButton ? true : false;

    const info = userEventThresholdGiftDetails?.data?.giftInfo?.skuInfo || [];

    const skuInfo = info && info.length > 0 && info[0] || {}

    const num = Number(giftThresholdAmount.replace(/,/g, "")) || 0;

    let roundedPercentage = (num == 0) ? 0 : Math.floor((totalPurchaseAmount / num) * 100); 

    if(roundedPercentage >= 100){
      roundedPercentage = 100;
      totalPurchaseAmount = num;
    }

    this._onUpdateProgressBar(roundedPercentage);

    this.setState({
      disableHomeButton: disableHomeButton,
      disableStoreButton: disableStoreButton,
      giftThresholdAmount: giftThresholdAmount,
      selectedAddressId: selectedAddressId || "",
      skuInfo: skuInfo,
      totalPurchaseAmount: totalPurchaseAmount,
    });
  }

  _onUpdateProgressBar = (progress,totalPurchaseAmount) => {
    let selectedObj;
    if(progress <= 0){
      selectedObj = this.progressText.progress0
    } else if((progress > 0) && (progress <= 25)){
      selectedObj = this.progressText.progress25
    } else if((progress > 25) && (progress <= 50)){
      selectedObj = this.progressText.progress50
    } else if((progress > 50) && (progress <= 99)){
      selectedObj = this.progressText.progress75   
    } else if((progress == 100)){
      selectedObj = this.progressText.progress100
    }

    if(totalPurchaseAmount || totalPurchaseAmount === 0){
      this.setState({
        totalPurchaseAmount: totalPurchaseAmount
      })
    }

    this.setState({
      selectedProgressObj: selectedObj,
      progress: progress
    })
  }

  _setAddressSelection = (e) => {
    if (e.value !== "") {
      this.setState({
        selectedAddressId: e.value,
      });
    } else {
      this.setState({
        selectedAddressId: "",
      });
    }
  };

   capitalizeFirstLetter = (string) => {
    const str = string && typeof string === 'string' && string.split(' ') || [];
    let finalStr = '';
    str.forEach((s) => {
      finalStr += s.charAt(0).toUpperCase() + s.slice(1) + ' ';
    })

    return finalStr.trim();
   }

  getEventThresholdGiftDetails = async() => {
    await this.props.getEventThresholdGiftDetails(this.props.eventId);
  }

  onSaveChangesClick = () => {
    const { selectedAddressId } = this.state;

    let requestObj = {
      addressId:
        selectedAddressId && selectedAddressId != "liverpoolStore"
          ? selectedAddressId
          : "",
      eventType: this.props.eventType,
      storeSelected: selectedAddressId == "liverpoolStore" ? true : false,
      eventId: this.props.eventId,
    };

    let isSuccess = false;

    saveEventThresholdGiftDetails(requestObj)
      .then((response) => {
        if (response.body.status.status === constAPISuccess) {
          this.props
            .getEventThresholdGiftDetails(this.props.eventId)
            .then((response) => {
              if (response.status.status === constAPISuccess) {
                response.data.giftInfo.diableStoreButton;
                const disableHomeButton = response?.data?.giftInfo
                  ?.diableStoreButton
                  ? true
                  : false;
                const disableStoreButton = response?.data?.giftInfo
                  ?.disableHomeButton
                  ? true
                  : false;
                
                const giftThresholdAmount = response?.data?.giftInfo?.giftThresholdAmount || '0';
                const info = response?.data?.giftInfo?.skuInfo || [];
                const skuInfo = info && info.length > 0 && info[0] || {}
                let totalPurchaseAmount = this.state.totalPurchaseAmount || 0;

                this.props.getPurchaseInfoDetails(this.props.eventId).then((response) => {
                  if (response.body.status.status === constAPISuccess) {
                    totalPurchaseAmount = response?.totalPurchaseAmount || this.state.totalPurchaseAmount;
                    const num = Number(giftThresholdAmount.replace(/,/g, "")) || 0;
                    let roundedPercentage = (num == 0) ? 0 : Math.floor((totalPurchaseAmount / num) * 100); 

                    if (roundedPercentage >= 100) {
                      roundedPercentage = 100;
                      totalPurchaseAmount = num;
                    }
                
                    this._onUpdateProgressBar(roundedPercentage,totalPurchaseAmount);
                  }
                });
                

                this.setState({
                  disableHomeButton: disableHomeButton,
                  disableStoreButton: disableStoreButton,
                  giftThresholdAmount: giftThresholdAmount,
                  selectedAddressId: selectedAddressId || "",
                  skuInfo: skuInfo,
                  totalPurchaseAmount: totalPurchaseAmount,
                });
              }
              if (response.status.status === constAPIFailure) {
                const { userEventThresholdGiftDetails } = this.props;

                const disableHomeButton = userEventThresholdGiftDetails?.data
                  ?.giftInfo?.disableHomeButton
                  ? true
                  : false;

                const disableStoreButton = userEventThresholdGiftDetails?.data
                  ?.giftInfo?.diableStoreButton
                  ? true
                  : false;

                this.setState({
                  disableHomeButton: disableHomeButton,
                  disableStoreButton: disableStoreButton,
                });
              }
            })
            .catch((e) => {
              console.log(e); // console required
            });
          isSuccess = true;
        }
        if (response.body.status.status === constAPIFailure) {
          isSuccess = false;
          console.log("service failed: status=", response.body.status.status);
        }
      })
      .catch((e) => {
        isSuccess = false;
        console.log(e); // console required
      });
  };

  render() {
    const {userDeliveryAddressOptions, selectedAddressId, disableStoreButton, disableHomeButton, selectedProgressObj, skuInfo, giftThresholdAmount, totalPurchaseAmount, progress} = this.state;

    const {userEventThresholdGiftDetails, eventType, eventInfo: {eventStatus} } = this.props;
    const isEventClosed = (eventStatus == 'Cerrado') ? true : false;

    const _address = {
      htmlId: "addressSelection",
      title: "selectAddress",
      displayName: "selectAddress",
      name: "addressSelectionRadios",
      defaultValue: "liverpool-store",
      options: userDeliveryAddressOptions,
    };

    let num = Number(giftThresholdAmount.replace(/,/g, "")) || 0;
    num = (num != totalPurchaseAmount) ? (num - totalPurchaseAmount) : num;
    const [main, cents] = num.toFixed(2).split(".");
    const formattedMain = Number(main).toLocaleString();

    const [totalPurchaseAmountNumMain, totalPurchaseAmountNumCents] = (totalPurchaseAmount !== null && totalPurchaseAmount !== undefined) ? totalPurchaseAmount.toFixed(2).split(".") : ["0", "00"];

    const formattedTotalPurchaseAmount = Number(totalPurchaseAmountNumMain).toLocaleString();
  
    const _imgsrcTracker = [
      {
        srcSet: skuInfo && skuInfo.skuImageUrl,
      },
    ];

    const imageAttrTracker = {
      id: "event-gift-image",
      src: skuInfo && skuInfo.skuImageUrl,
      className: skuInfo && skuInfo.skuImageUrl ? "gift-image-EG" : "gift-no-image-EG",
      altImg: commonUtil.getAssetURL() + "/images/guest/no-image.png",
    };

    const pedidoNumber =
      (userEventThresholdGiftDetails &&
        userEventThresholdGiftDetails.data &&
        userEventThresholdGiftDetails.data.giftInfo &&
        userEventThresholdGiftDetails.data.giftInfo.remissionNo) ||
      '';

    const trackingUrl =
      commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        'adminpage.regalodelevento.order.redirect.url',
      );

    const selectedOption = _address.options.find(
      (option) => selectedAddressId == option.value
    );
    
    const fallbackName =
      this.props?.eventInfo?.user1firstName;
    
    const renderStoreInfo = (text) => (
      <div className='store-info-container'>
        <div
          className='icon-wrapper-div'
          data-disabled='Yes'
          data-selected='Yes'
        >
          <div className='icon-background'>
            <div className='icon-dot'></div>
          </div>
        </div>
        <div className='store-text'>{text}</div>
      </div>
    );

    return (
      <div className="gift-container">
        <div className="gift-section">
          <div className="gift-card-EG">
            <div className="gift-header">
              <div className="gift-status col-3">
                <div className="gift-icon-wrapper" id="event-gift-circular-progress-bar">
                  <CircularProgressBar percentage={progress} selectedProgressObj={selectedProgressObj}/>
                </div>
                <div className="gift-status-label">{commonUtil.getLabel(
                  this.props.lables.EventAdminPage,
                  "adminpage.regalodelevento.gift.status.text.label"
                )}</div>
                <div className="gift-amount">
                  <span className="gift-currency">${formattedTotalPurchaseAmount}</span>
                  <span className="gift-cents">{totalPurchaseAmountNumCents}</span>
                </div>
              </div>
              <div className="gift-description col-9">
                <div className="gift-title-EG">{commonUtil.getLabel(
                  this.props.lables.EventAdminPage,
                  "adminpage.regalodelevento.progress100.text.headertxt.label"
                )}</div>
                <div className={`gift-message-text-value ${ progress > 0 ? '' : 'gift-message-text-value-no-progress'}`}>
                  <span className="gift-highlight">
                    {selectedProgressObj.green}{formattedMain}<sup className="gift-cents-2">{cents}</sup>
                  </span>
                  <span className="gift-regular">
                    {" "}
                    {selectedProgressObj.grey}{" "}
                  </span>
                </div>
              </div>
            </div>
            {Object.keys(skuInfo).length == 0 ? <div>{commonUtil.getLabel(
                this.props.lables.EventAdminPage,
                "adminpage.regalodelevento.no.sku.text.label"
              )}</div> :
            <div className="gift-info">
              <div className="gift-image-section">
                <Image imageAttr={imageAttrTracker} _imgsrc={_imgsrcTracker} />
                <div className="gift-details-EG">
                  <div className="gift-type">
                    <span className="gift-type-label">{commonUtil.getLabel(
                        this.props.lables.EventAdminPage,
                        "adminpage.regalodelevento.event.type.text.label"
                      )}</span>
                    <span className="gift-type-value">{eventType && this.capitalizeFirstLetter(eventType)}</span>
                  </div>
                  <div className="gift-description-text">
                    {skuInfo && skuInfo.skuName}
                  </div>
                </div>
              </div>
            </div>}
          </div>
          <div className="gift-disclaimer">
            {commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalodelevento.gift.disclaimer.text.label"
            )}
          </div>
        </div>
        <div className="gift-pickup-section">
          <div className="divider"></div>
          <div className="pickup-title">{commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalodelevento.pickup.title.text.label"
            )}<div className="gift-text" style={{ display: (disableStoreButton && disableHomeButton && (selectedAddressId.length !== 0)) ? "flex" : "none" }}>{(selectedAddressId == "liverpoolStore") ? commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalodelevento.pickup.store.text.label"
            ) : commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalodelevento.pickup.address.text.label"
            )}</div></div>
          <div className="pickup-options">
            <div>
              { ((selectedAddressId && (selectedAddressId.length == 0)) || (!disableStoreButton && !disableHomeButton)) ?
                _address.options.map((option,index) => (
                  <div style={{ display: (disableStoreButton && disableHomeButton && (selectedAddressId.length !== 0) && (selectedAddressId !== option.value)) ? "none" : "block" }}>
                    <RadioButton
                      key={index}
                      displayName={option.displayName}
                      id={option.id}
                      value={option.value}
                      title={option.title}
                      // checked={(disableStoreButton && disableHomeButton && (selectedAddressId.length !== 0) || (selectedAddressId === option.value)) || false}
                      radioCssClass={"custom-radio"}
                      name={_address.name}
                      onChangeFunction={(e) => this._setAddressSelection(e)}
                      disabled={(selectedAddressId.length !== 0 ? ((option.value == 'liverpoolStore') ? disableStoreButton : disableHomeButton) : false)}
                    />
                  </div>
                ))
               : selectedOption
                  ? renderStoreInfo(selectedOption.displayName)
                  : fallbackName
                    ? renderStoreInfo(`Recibir en ${fallbackName}`)
                    : null}
            </div>
          </div>
          {(pedidoNumber) && <OrderInfo trackingUrl={trackingUrl} pedidoNumber={pedidoNumber} lables={this.props.lables} />}
        </div>
        {this.props.isWap ? (
          <div
            className="buttonBlock button-border-top"
            id="gift-list-contract-btn"
            style={{ visibility: (disableStoreButton && disableHomeButton) || (isEventClosed) ? "hidden" : "visible" }}
          >
            <div className={`col-xs-6 col-sm-6 col-lg-6 mb-60`}>
              <div className="buttonBlock newButtonBlock">
                <button
                  className={`btnSecondaryAction size-Large btnSecondaryAction size-Full`}
                  style={{
                    '--color-500': this.props.selectedTheme?.color_500 || "#333",
                  }}
                  aria-hidden="false"
                  onClick={this.props.hideModalOverlay}
                >
                  {commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.regalodelevento.back.button.text.label"
                  )}
                </button>
              </div>
            </div>
            <div className={`col-xs-6 col-sm-6 mb-60 col-lg-6`}>
              <div className="buttonBlock newButtonBlock">
                <button
                  disabled={(this.state.selectedAddressId.length == 0) ? true : false}
                  style={{
                    '--color-500': this.props.selectedTheme?.color_500 || "#333",
                  }}
                  className={`btnPrimary size-Large size-Full ${(this.state.selectedAddressId.length == 0) && 'disabledButton'}`}
                  aria-hidden="false"
                  onClick={this.onSaveChangesClick}
                >
                  {commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.regalodelevento.save.button.text.label"
                  )}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div
            id="#event-gift-modal-overlay"
            className={`col-xs-12 col-sm-12 mb-90 col-lg-12 button-border-top`}
            style={{ display: (disableStoreButton && disableHomeButton) || (isEventClosed) ? "none" : "block" }}
          >
            <div className="buttonBlock newButtonBlock">
              <button
                  disabled={(this.state.selectedAddressId.length == 0) ? true : false}
                  style={{
                    '--color-500': this.props.selectedTheme?.color_500 || "#333",
                  }}
                  className={`btnPrimary size-Large size-Full ${(this.state.selectedAddressId.length == 0) && 'disabledButton'}`}
                  aria-hidden="false"
                  onClick={this.onSaveChangesClick}
                >
                 {commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.regalodelevento.save.button.text.label"
                  )}
              </button> 
          </div>
          </div>
        )}
      </div>
    );
  }
}

export default EventGiftSummary;
